export const testimonials = [
  {
    quote:
      "Organicé todo el menú de Navidad en una tarde. Supe exactamente qué cocinar, en qué orden prepararlo y cómo presentarlo. Nunca más improvisé en las fiestas.",
    name: "Lucía M.",
    city: "Buenos Aires",
    role: "Mamá y anfitriona de todas las reuniones familiares",
  },
  {
    quote:
      "El vitel toné me quedó mejor que el de la confitería. Mi familia no lo podía creer. Y lo hice siguiendo los pasos del tomo, sin ninguna experiencia previa.",
    name: "Romina G.",
    city: "Rosario",
    role: "Ama de casa, primera vez cocinando para 15 personas",
  },
  {
    quote:
      "Antes de las fiestas entraba en pánico. Ahora abro el megapack, elijo el menú, leo los tiempos de preparación y listo. En 10 minutos ya sé exactamente qué hacer.",
    name: "Valentina F.",
    city: "Córdoba",
    role: "Trabaja todo el día y recibe a su familia en las fiestas",
  },
];
export const painPoints = [
  { title: "Llegás a la fecha sin saber qué cocinar", text: "Sin un menú claro para Halloween, Navidad o Año Nuevo." },
  { title: "Siempre las mismas recetas de siempre", text: "Sin ideas nuevas que sorprendan a tus invitados este año." },
  { title: "Te estresás días antes", text: "Sin saber qué preparar primero ni cómo organizar los tiempos." },
  { title: "Los platos no te quedan como en las fotos", text: "Sin guías paso a paso que te expliquen cada detalle." },
  { title: "No sabés qué hacer con los celíacos o veganos de la mesa", text: "Y terminan comiendo menos que el resto." },
  { title: "Recetas de YouTube que nunca quedan igual", text: "Sin adaptación a los ingredientes y marcas argentinas." },
  { title: "La mesa dulce siempre te gana", text: "No sabés cómo armarla para que quede linda y abundante." },
  { title: "Diciembre llega y siempre empezás de cero", text: "Sin un sistema de recetas que te resuelva todo de una vez." },
];
export const audiences = [
  {
    title: "Anfitrionas que quieren lucirse",
    text: "Que reciben en Halloween, Navidad o Año Nuevo y quieren una mesa que impresione de verdad.",
    isNew: false,
  },
  {
    title: "Cocinás en casa con lo que hay",
    text: "Con ingredientes de cualquier supermercado argentino te alcanza. Sin productos importados ni caros.",
    isNew: false,
  },
  {
    title: "Para toda la mesa sin excepción",
    text: "Incluye opciones sin TACC y veganas para que nadie en tu mesa se quede sin comer rico.",
    isNew: true,
  },
  {
    title: "Buscás resultados visibles rápido",
    text: "Vas por la mesa dulce perfecta, el vitel toné cremoso, el pan dulce casero o el brindis de medianoche inolvidable.",
    isNew: false,
  },
];
export const topicTags = [
  "Halloween", "Navidad", "Año Nuevo", "Mesa dulce", "Platos principales", "Tragos festivos",
  "Sin TACC", "Vegano", "Postres", "Emplatado", "Presentación", "Anticipación",
];
export const occasions = [
  "Halloween", "Nochebuena", "Navidad", "Año Nuevo", "Mesa dulce", "Mesa salada",
  "Picadas", "Tragos sin alcohol", "Postres argentinos", "Recetas sin TACC", "Opciones veganas", "Brindis de medianoche",
];
export const volumeGroups = [
  {
    season: "Halloween",
    month: "31 de octubre",
    volumes: [
      {
        code: "T1",
        title: "La Mesa del Terror",
        subtitle: "Las recetas que nadie olvida",
        text: "Picadas, snacks y tragos temáticos que sorprenden desde que llegan los invitados. Todo con ingredientes fáciles de conseguir y pasos tan claros que salen a la primera.",
        bullets: ["Snacks y picadas temáticas paso a paso", "Tragos festivos con versión sin alcohol", "Listos en menos de 30 minutos"],
      },
      {
        code: "T2",
        title: "Dulces Monstruosos",
        subtitle: "Mesa dulce terroríficamente deliciosa",
        text: "Cupcakes, tortas decoradas y mesa dulce de Halloween que parecen de pastelería profesional. Con guía de armado de mesa incluida.",
        bullets: [],
      },
    ],
  },
  {
    season: "Navidad",
    month: "24 y 25 de diciembre",
    volumes: [
      {
        code: "T3",
        title: "Navidad en la Mesa",
        subtitle: "La cena navideña perfecta, sin estrés",
        text: "Platos principales, ensaladas y guarniciones navideñas con los sabores de siempre y la presentación que siempre quisiste lograr. Con tiempos de preparación anticipada para que estés tranquila cuando lleguen.",
        bullets: [],
      },
      {
        code: "T4",
        title: "Dulce Navidad",
        subtitle: "Pan dulce, budines y mesa dulce navideña",
        text: "Pan dulce casero, budines de naranja, turrones y pionono navideño. Con guía completa para armar la mesa dulce más linda que tuviste.",
        bullets: [],
      },
    ],
  },
  {
    season: "Año Nuevo",
    month: "31 de diciembre",
    volumes: [
      {
        code: "T5",
        title: "La Previa Perfecta",
        subtitle: "Todo listo antes de que llegue el primero",
        text: "Tablas de picada, blinis, empanadas de hojaldre y bocaditos que podés preparar horas antes y dejar en la heladera. Para que vos también disfrutes la previa.",
        bullets: [],
      },
      {
        code: "T6",
        title: "El Brindis Soñado",
        subtitle: "El momento de medianoche que nadie olvida",
        text: "Tragos sin alcohol, mocktails tropicales, paletas heladas de verano y bocaditos de medianoche. La guía completa para que el brindis de las 00:00 sea el momento más recordado de la noche.",
        bullets: [],
      },
    ],
  },
];
export const bonuses = [
  {
    code: "B1",
    title: "Postres Que Enamoran",
    text: "Los mejores postres caseros argentinos para cerrar cada festejo con el sabor que todos recuerdan. Chocotorta, rogel, mousse y volcán de chocolate incluidos.",
  },
  {
    code: "B2",
    title: "Sin TACC, Sin Límites",
    text: "Recetas para celíacos tan deliciosas que nadie nota la diferencia. Con guía de harinas sin TACC disponibles en supermercados argentinos y alertas de ingredientes con trazas.",
  },
  {
    code: "B3",
    title: "La Mesa Verde",
    text: "Opciones veganas tan ricas y abundantes que el resto de los invitados también va a querer repetir. Con tabla de sustituciones veganas y dónde conseguirlas en Argentina.",
  },
];
export const comparisonRows = [
  { without: "Horas buscando recetas en YouTube que nunca quedan igual", with: "Recetas probadas con ingredientes argentinos paso a paso" },
  { without: "Siempre los mismos platos de siempre", with: "200+ recetas para Halloween, Navidad y Año Nuevo" },
  { without: "Estrés y pánico días antes de cada festejo", with: "Tiempos de preparación anticipada para cada receta" },
  { without: "Sin saber qué hacer con celíacos o veganos", with: "Bonos completos de Sin TACC y vegano incluidos" },
  { without: "Mesa dulce que nunca te queda como querés", with: "Guía de armado de mesa dulce paso a paso" },
  { without: "Cada año empezás de cero", with: "Un sistema de recetas que te resuelve todo el trimestre" },
  { without: "Platos que no lucen como en las fotos", with: "Guías de emplatado y presentación en cada receta" },
  { without: "Sin saber coordinar los tiempos de cocina", with: "Líneas de tiempo de preparación por festividad" },
];
export const premiumVolumes = [
  {
    code: "TP1",
    title: "Nivel Chef: Técnicas Que Impresionan",
    text: "Las técnicas profesionales que transforman una receta buena en una experiencia inolvidable. Cocción a baja temperatura, emplatado de restaurante, salsas reducidas y presentaciones que parecen de revista gastronómica.",
  },
  {
    code: "TP2",
    title: "La Anfitriona Legendaria",
    text: "Menús completos coordinados de entrada, principal y postre para Halloween, Navidad y Año Nuevo. Con líneas de tiempo del día de la fiesta, guía de montaje de mesa y los secretos de coordinación para que todo fluya perfecto mientras vos también disfrutás.",
  },
];
export const faqs = [
  {
    q: "¿Cómo recibo el Megapack después de comprar?",
    a: "Al confirmar el pago recibís acceso inmediato por email con el link de descarga de todos los tomos y bonos en formato PDF. En menos de 5 minutos ya lo tenés en tu teléfono o computadora.",
  },
  {
    q: "¿Sirve si nunca cociné algo elaborado?",
    a: "Sí, completamente. Los 6 tomos principales están diseñados para principiantes e intermedias. Cada receta tiene pasos numerados, tiempos exactos y fotos del proceso para que salga a la primera.",
  },
  {
    q: "¿Los ingredientes se consiguen en cualquier supermercado argentino?",
    a: "Sí. Todas las recetas están pensadas con ingredientes de Carrefour, Coto, Día o su supermercado de barrio. Sin productos importados ni difíciles de conseguir.",
  },
  {
    q: "¿Los 3 bonos están incluidos en las dos ofertas?",
    a: "Sí. Los bonos de Postres, Sin TACC y Vegano están incluidos tanto en el Megapack Base como en el Premium sin costo adicional.",
  },
  {
    q: "¿Sirve si en mi familia hay celíacos o veganos?",
    a: "Sí, exactamente para eso están los bonos Sin TACC y La Mesa Verde. Cada uno tiene 7 recetas completas con guías de ingredientes seguros y dónde conseguirlos en Argentina.",
  },
  {
    q: "¿Qué diferencia tiene con recetas gratis de Instagram o YouTube?",
    a: "Las recetas de redes no están adaptadas a ingredientes argentinos, no tienen tiempos de preparación anticipada ni guías de coordinación de menú completo. El Megapack está diseñado específicamente para que puedas organizar una fiesta completa de principio a fin, no solo cocinar un plato suelto.",
  },
  {
    q: "¿Para qué festividades sirve?",
    a: "Halloween, Navidad y Año Nuevo. Los 6 tomos cubren el último trimestre completo del año — el período de mayor festejo de Argentina.",
  },
  {
    q: "¿Por qué elegir el Premium y no el Base?",
    a: "El Premium agrega los 2 tomos de técnicas avanzadas y menús coordinados completos. Si querés que tus invitados no solo coman rico sino que vivan una experiencia gastronómica de principio a fin, el Premium es para vos.",
  },
  {
    q: "¿Tiene garantía real?",
    a: "Sí. 7 días completos desde la compra. Si no quedás satisfecha, te devolvemos el 100% del dinero sin preguntas ni formularios.",
  },
];
